// Shared by the row- and group-reorder controllers: PATCH an order to a sort
// endpoint and say only whether it was written. Both endpoints answer `head :ok`
// or `head :unprocessable_content`, so there is no body to read.
//
// Not a `*_controller.js` file on purpose — everything matching that glob in
// `app/vite/controllers` is auto-registered as a Stimulus controller.
export async function patchOrder(url, body) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;

  try {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });
    return response.ok;
  } catch {
    return false;
  }
}
